import { render, staticRenderFns } from "./BlockContentForm.vue?vue&type=template&id=77b57b9c&"
import script from "./BlockContentForm.vue?vue&type=script&lang=js&"
export * from "./BlockContentForm.vue?vue&type=script&lang=js&"
import style0 from "./BlockContentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports